import m from "../../es2015/lang/hi_IN";
window.am4lang_hi_IN = m;


//////////////////
// WEBPACK FOOTER
// ./lang/hi_IN.js
// module id = null
// module chunks = 